<script lang="ts" setup>
const props = defineProps({
  more: {
    type: String,
    default: () => {
      const { $t } = useI18n()
      return $t('Read more')
    },
  },
  less: {
    type: String,
    default: () => {
      const { $t } = useI18n()
      return $t('Collapse')
    },
  },
})

const open = ref(false)
const contentEl = ref<HTMLElement>()
const hasOverflow = ref(false)

const buttonText = computed(() => {
  return open.value ? props.less : props.more
})

const checkOverflow = () => {
  if (!contentEl.value) return
  const hasVerticalOverflow = contentEl.value.scrollHeight > contentEl.value.clientHeight
  // const hasHorizontalOverflow = contentEl.value.scrollWidth > contentEl.value.clientWidth
  hasOverflow.value = hasVerticalOverflow// || hasHorizontalOverflow
}

let resizeObserver: ResizeObserver | null = null

onMounted(() => {
  if (contentEl.value) {
    checkOverflow()
    resizeObserver = new ResizeObserver(() => {
      checkOverflow()
    })
    resizeObserver.observe(contentEl.value)
  }
})

onUnmounted(() => {
  if (resizeObserver) {
    resizeObserver.disconnect()
  }
})

watch(() => contentEl.value, () => {
  nextTick(() => {
    checkOverflow()
  })
}, { flush: 'post' })
</script>

<template>
  <div
    :class="{
      'read-more--open': open,
      'read-more--has-overflow': hasOverflow,
    }"
    class="read-more"
  >
    <div
      ref="contentEl"
      class="read-more__content"
    >
      <slot />
    </div>
    <button
      type="button"
      class="read-more__toggle"
      :aria-expanded="open"
      :aria-label="buttonText"
      @click="open = !open"
    >
      <span>{{ buttonText }}</span>
      <Icon
        name="icon:arrow"
        class="icon icon--arrow"
      />
    </button>
  </div>
</template>

<style>
@import url("~layers/app/components/Ui/ReadMore.css");
</style>
